import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'

import { FunctionComponent } from 'react'
import LoginIcon from '@mui/icons-material/Login'
import { useLoginWithRedirect } from '@frontegg/react'

interface Props {
  handleClose: Function
}
const LoginMenuItem: FunctionComponent<Props> = ({ handleClose }) => {
  const loginWithRedirect = useLoginWithRedirect()

  const login = () => {
    handleClose()
    loginWithRedirect()
  }

  return (
    <MenuItem onClick={login} data-testid="login">
      <ListItemIcon>
        <LoginIcon fontSize="small" sx={{ color: 'primary.main' }} />
      </ListItemIcon>
      <ListItemText>Sign in</ListItemText>
    </MenuItem>
  )
}

export default LoginMenuItem
